// アクセシビリティ要件を満たすモーダルを実装します。
// fyi: https://zenn.dev/dqn/articles/36045bb89d5d69
// モーダル要素に role 属性、aria-modal 属性、aria-labelledby 属性、aria-describedby 属性が付与されている
// モーダルを開くと、モーダル内の最初の focusable な要素に自動でフォーカスされる
// モーダルが開いている間、モーダル以外の要素に aria-hidden 属性が付与される
// モーダルが開いている間、モーダル以外の要素のスクロールが無効化される
// モーダルが開いている間、モーダル内でフォーカスがトラップされる
// Esc キーを押下すると、モーダルが閉じる
// モーダルの外側をクリックすると、モーダルが閉じる
// モーダルを閉じると、モーダルが開く前にフォーカスされていた要素にフォーカスが戻る

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
export default function YoutubePlayerApi() {
  // 【CSS+JS】モーダルウィンドウを表示しその中にYouTube動画を動的に埋め込む
  // fyi: https://autovice.jp/articles/154

  window.addEventListener(
    "DOMContentLoaded",
    function () {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    },
    false,
  );

  /**
   * @class ToggleModal
   * @description モーダルウィンドウの表示切替を行い、YouTube動画を動的に埋め込む
   * @argument target 対象のYouTube動画を含む要素
   */
  class ToggleModal {
    constructor(target) {
      this.target = target;
      this.videoId = target.dataset.url.slice(-11);
      // this.loadIframePlayerAPI();
      this.open();
      this.close();
      this.closeEscape();
    }

    // /**
    //  * @method loadIframePlayerAPI
    //  * @description IFrame Player APIを読み込む
    //  */
    // loadIframePlayerAPI() {
    //   const tag = document.createElement('script');
    //   tag.src = 'https://www.youtube.com/iframe_api';
    //   const firstScriptTag = document.getElementsByTagName('script')[0];
    //   firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    // }

    /**
     * @method onYouTubeIframeAPIReady
     * @description YouTube動画を動的に埋め込む
     */
    onYouTubeIframeAPIReady() {
      const ytPlayer = new YT.Player("player", {
        videoId: this.videoId,
        playerVars: {
          autoplay: 1,
          rel: 0,
        },
      });
    }

    /**
     * @method remakePlayerElement
     * @description YouTube動画を埋め込む要素を再作成
     */
    remakePlayerElement() {
      const modal = document.querySelector("#modal_video .player-wrap");
      // const modal = document.querySelector('#modal_video');
      modal.removeChild(modal.firstElementChild);
      let tag = document.createElement("div");
      tag.id = "player";
      modal.appendChild(tag);
    }

    /**
     * @method open
     * @description モーダルウィンドウを開く
     */
    open() {
      this.target.addEventListener("click", (event) => {
        this.onYouTubeIframeAPIReady();
        document.querySelector("#modal_video").classList.add("is-open");
        document.querySelector("#modal_video").classList.remove("is-close");
        this.target.setAttribute("aria-expanded", "ture"); //展開中
        document.querySelector("#modal_video .player-wrap").setAttribute("aria-modal", "true");
        document.querySelector("#modal_video").setAttribute("aria-hidden", "false"); //展開中：スクリーンリーダーで読み上げる
        document.body.style.overflow = "hidden";

        // //bodyにクラスを追加
        // document.body.classList.add("is-modal-video-open");
      });
    }

    /**
     * @method close
     * @description モーダルウィンドウを閉じる
     */
    close() {
      document.querySelector(".js-modal-video-close").addEventListener("click", (event) => {
        document.querySelector("#modal_video").classList.add("is-close");
        document.querySelector("#modal_video").classList.remove("is-open");
        this.target.setAttribute("aria-expanded", "false"); //折り畳み中
        document.querySelector("#modal_video .player-wrap").setAttribute("aria-modal", "false");
        document.querySelector("#modal_video").setAttribute("aria-hidden", "true"); //折り畳み中：スクリーンリーダーで読み上げない
        document.body.style.overflow = "";
        this.remakePlayerElement();

        // //bodyにクラスを削除
        // document.body.classList.remove("is-modal-video-open");
      });
    }

    closeEscape() {
      window.addEventListener("keydown", (event) => {
        event.preventDefault();
        if (event.key === "Escape") {
          document.querySelector(".js-modal-video-close").click();
          console.log("Escapeキー");
        }
      });
    }
  }

  document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-modal-video-open").forEach((element) => {
      new ToggleModal(element);
    });
  });
}

// html sample
/*
<div class="p-movie">
  <div class="p-movie__video"><!-- モーダル + YouTube Player API + 自動再生 -->
    <a class="js-modal-video-open" data-url="https://www.youtube.com/watch?v=lJIrF4YjHfQ" aria-expanded="false">
      <div class="p-movie__video-thumb">
        <img src="http://img.youtube.com/vi/lJIrF4YjHfQ/maxresdefault.jpg" width="1280" height="720">
      </div>
    </a>
  </div>
  <div class="p-movie__video"><!-- モーダル + YouTube Player API + 自動再生 -->
    <a class="js-modal-video-open" data-url="https://www.youtube.com/watch?v=zGruPOYlvRs" aria-expanded="false">
      <div class="p-movie__video-thumb">
        <img src="http://img.youtube.com/vi/zGruPOYlvRs/maxresdefault.jpg" width="1280" height="720">
      </div>
    </a>
  </div>
  <div class="p-movie__video"><!-- 通常の埋め込み -->
    <div class="p-movie__video-embed">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/lJIrF4YjHfQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
  <div class="p-movie__video"><!-- 通常の埋め込み -->
    <div class="p-movie__video-embed">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/zGruPOYlvRs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>

  <style>
    #modal_video.is-close{
      display: none;
    }
  </style>
  
  <div id="modal_video" class="is-close js-modal-video-close" aria-hidden="true">
    <div class="player-wrap" tabindex="-1" aria-labelledby="選択した動画を再生" aria-modal="false" role="dialog"><!-- モーダルウィンドウのコンテナ要素 -->
      <div id="player"></div>
    </div>

    <button class="modal-video__close" title="閉じる" aria-label="閉じる（エスケープキーを押して閉じる）"></button>
  </div>
</div>
*/
